import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
export var OffscreenWatcher = function OffscreenWatcher(_ref) {
  var onScreenChange = _ref.onScreenChange,
    _ref$lowThreshold = _ref.lowThreshold,
    lowThreshold = _ref$lowThreshold === void 0 ? 0.0 : _ref$lowThreshold,
    _ref$highThreshold = _ref.highThreshold,
    highThreshold = _ref$highThreshold === void 0 ? 0.6 : _ref$highThreshold;
  var elementRef = React.useRef(null);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    mostlyOnScreen = _useState2[0],
    setMostlyOnScreen = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    fullyOffScreen = _useState4[0],
    setFullyOffScreen = _useState4[1];

  // will only switch to true once mostlyOnScreen
  // will only switch to false once fullyOffScreen
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    onScreen = _useState6[0],
    setOnScreen = _useState6[1];

  // update state when thresholds are crossed
  useEffect(function () {
    if (fullyOffScreen) {
      setOnScreen(false);
      return;
    }
    if (mostlyOnScreen) {
      setOnScreen(true);
      return;
    }
  }, [mostlyOnScreen, fullyOffScreen]);

  // Set initial state on mount & when onScreen changes
  useEffect(function () {
    onScreenChange(onScreen);
  }, [onScreen]);

  // Actual monitoring of onscreen status
  useEffect(function () {
    var highThresholdObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setMostlyOnScreen(entry.isIntersecting);
      });
    }, {
      threshold: highThreshold
    });
    var lowThresholdObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setFullyOffScreen(!entry.isIntersecting);
      });
    }, {
      threshold: lowThreshold
    });
    lowThresholdObserver.observe(elementRef.current);
    highThresholdObserver.observe(elementRef.current);
    return function () {
      lowThresholdObserver.disconnect();
      highThresholdObserver.disconnect();
    };
  }, [lowThreshold, highThreshold]);

  // Note that we only use a narrow bar rather than matching the full width of the
  // element being observed.
  // We only care about vertical visibility for rive animations, and if part of the
  // element is offscreen to the side, it'll count against the intersection ratio.

  return /*#__PURE__*/React.createElement("div", {
    ref: elementRef,
    style: {
      position: 'absolute',
      left: '50%',
      top: 0,
      width: '10px',
      height: '100%',
      visibility: 'hidden',
      pointerEvents: 'none'
    }
  });
};